<script setup>
import { computed } from "vue";
import FormSelect from "v3/components/Form/Select.vue";

const props = defineProps({
  value: { type: [Number, String], default: 15 },
  label: { type: String, default: "" },
  description: { type: String, default: "" },
});
const emit = defineEmits(["change"]);

const options = [
  { value: 0, label: "Off" },
  { value: 5, label: "5s" },
  { value: 10, label: "10s" },
  { value: 15, label: "15s" },
  { value: 30, label: "30s" },
];

const selectedValue = computed({
  get: () => String(props.value),
  set: value => emit("change", Number(value)),
});
</script>

<template>
  <div class="flex gap-2 justify-between w-full items-start">
    <div>
      <label class="text-n-gray-12 font-medium leading-6 text-sm">{{ label }}</label>
      <p class="text-n-gray-11">{{ description }}</p>
    </div>
    <FormSelect
      v-model="selectedValue"
      name="undoSendDelay"
      spacing="compact"
      class="min-w-28 mt-px"
      :value="selectedValue"
      :options="options"
      label=""
    >
      <option
        v-for="option in options"
        :key="option.value"
        :value="String(option.value)"
        :selected="String(option.value) === selectedValue"
      >
        {{ option.label }}
      </option>
    </FormSelect>
  </div>
</template>
